 <!--
# -----------------------------------------------------------------------------
# Component: undoPolicyRelease.vue
# Author: PST
# Created Date: 06/May/2020
# Comments: Undo Policy Release
# -----------------------------------------------------------------------------
-->
<template>
  <page>
    <v-container fluid grid-list-md>
      <message :messages="messages"></message>
      <v-layout row wrap>
        <v-flex xs12>
          <form>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg4 xs6>
                            <v-autocomplete
                              :items="params.mainClasses"
                              v-model="filters.mainClasses"
                              :label="filtersLabel.mainClasses"
                              item-text="label"
                              item-value="value"
                              data-vv-name="mainClasses"
                              :data-vv-as="filtersLabel.mainClasses"
                              :error-messages="errors.collect('mainClasses')"
                              @change="valMainClasses"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex lg8 xs6> </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.polNo"
                              :label="filtersLabel.polNo"
                              :error-messages="errors.collect('polNo')"
                              data-vv-name="polNo"
                              :data-vv-as="filtersLabel.polNo"
                              v-validate="'entry|max:16|min_char:3'"
                              :maxlength="16"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.moCmpNo"
                              :label="filtersLabel.moCmpNo"
                              :error-messages="errors.collect('moCmpNo')"
                              data-vv-name="moCmpNo"
                              :data-vv-as="filtersLabel.moCmpNo"
                              v-validate="'entry|max:16'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.insdName1"
                              :label="filtersLabel.insdName1"
                              :error-messages="errors.collect('insdName1')"
                              data-vv-name="insdName1"
                              :data-vv-as="filtersLabel.insdName1"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <cal-picker
                              v-model="filters.comDate"
                              :label="filtersLabel.comDate"
                              :error-messages="errors.collect('comDate')"
                              data-vv-name="comDate"
                              :data-vv-as="filtersLabel.comDate"
                            ></cal-picker>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <cal-picker
                              v-model="filters.expDate"
                              :label="filtersLabel.expDate"
                              :error-messages="errors.collect('expDate')"
                              data-vv-name="expDate"
                              :data-vv-as="filtersLabel.expDate"
                            ></cal-picker>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <cal-picker
                              v-model="filters.tranDate"
                              :label="filtersLabel.tranDate"
                              :error-messages="errors.collect('tranDate')"
                              data-vv-name="tranDate"
                              :data-vv-as="filtersLabel.tranDate"
                            ></cal-picker>
                          </v-flex>
                        </v-layout>
                        <transition name="slide-x-transition" mode="out-in">
                          <v-layout row wrap v-if="showDetailFilters">
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.insdRefNo"
                                :label="filtersLabel.insdRefNo"
                                :error-messages="errors.collect('insdRefNo')"
                                data-vv-name="insdRefNo"
                                :data-vv-as="filtersLabel.insdRefNo"
                                v-validate="'entry|max:8'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.icNo"
                                :label="filtersLabel.icNo"
                                :error-messages="errors.collect('icNo')"
                                data-vv-name="icNo"
                                :data-vv-as="filtersLabel.icNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.riCo"
                                :label="filtersLabel.riCo"
                                :error-messages="errors.collect('riCo')"
                                data-vv-name="riCo"
                                :data-vv-as="filtersLabel.riCo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.acctNo1"
                                :label="filtersLabel.acctNo1"
                                :error-messages="errors.collect('acctNo1')"
                                data-vv-name="acctNo1"
                                :data-vv-as="filtersLabel.acctNo1"
                                v-validate="'entry|max:8'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.cedPolNo"
                                :label="filtersLabel.cedPolNo"
                                :error-messages="errors.collect('cedPolNo')"
                                data-vv-name="cedPolNo"
                                :data-vv-as="filtersLabel.cedPolNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.cedCesNo"
                                :label="filtersLabel.cedCesNo"
                                :error-messages="errors.collect('cedCesNo')"
                                data-vv-name="cedCesNo"
                                :data-vv-as="filtersLabel.cedCesNo"
                                v-validate="'entry|max:40'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.brkSlipNo"
                                :label="filtersLabel.brkSlipNo"
                                :error-messages="errors.collect('brkSlipNo')"
                                data-vv-name="brkSlipNo"
                                :data-vv-as="filtersLabel.brkSlipNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="filters.brkTranRef"
                                :label="filtersLabel.brkTranRef"
                                :error-messages="errors.collect('brkTranRef')"
                                data-vv-name="brkTranRef"
                                :data-vv-as="filtersLabel.brkTranRef"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showVesNo">
                              <v-text-field
                                v-model="filters.vesNo"
                                :label="filtersLabel.vesNo"
                                :error-messages="errors.collect('vesNo')"
                                data-vv-name="vesNo"
                                :data-vv-as="filtersLabel.vesNo"
                                v-validate="'entry|max:7'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showVesName">
                              <v-text-field
                                v-model="filters.vesName"
                                :label="filtersLabel.vesName"
                                :error-messages="errors.collect('vesName')"
                                data-vv-name="vesName"
                                :data-vv-as="filtersLabel.vesName"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showVesName"> </v-flex>
                            <v-flex lg4 xs6 v-if="showVoyNo">
                              <v-text-field
                                v-model="filters.voyNo"
                                :label="filtersLabel.voyNo"
                                :error-messages="errors.collect('voyNo')"
                                data-vv-name="voyNo"
                                :data-vv-as="filtersLabel.voyNo"
                                v-validate="'entry|max:6'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showVoyDesc">
                              <v-text-field
                                v-model="filters.voyDesc"
                                :label="filtersLabel.voyDesc"
                                :error-messages="errors.collect('voyDesc')"
                                data-vv-name="voyDesc"
                                :data-vv-as="filtersLabel.voyDesc"
                                v-validate="'entry|max:120'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showVoyDesc"> </v-flex>
                            <v-flex lg4 xs6 v-if="showRiskLoc">
                              <v-text-field
                                v-model="filters.riskLoc"
                                :label="filtersLabel.riskLoc"
                                :error-messages="errors.collect('riskLoc')"
                                data-vv-name="riskLoc"
                                :data-vv-as="filtersLabel.riskLoc"
                                v-validate="'entry|max:40'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showRiskLoc"> </v-flex>
                            <v-flex lg4 xs6 v-if="showRiskLoc"> </v-flex>
                            <v-flex lg4 xs6 v-if="showContrt">
                              <v-text-field
                                v-model="filters.contrt"
                                :label="filtersLabel.contrt"
                                :error-messages="errors.collect('contrt')"
                                data-vv-name="contrt"
                                :data-vv-as="filtersLabel.contrt"
                                v-validate="'entry|max:8'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showContrt"> </v-flex>
                            <v-flex lg4 xs6 v-if="showContrt"> </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor">
                              <v-text-field
                                v-model="filters.vehRegNo"
                                :label="filtersLabel.vehRegNo"
                                :error-messages="errors.collect('vehRegNo')"
                                data-vv-name="vehRegNo"
                                :data-vv-as="filtersLabel.vehRegNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor">
                              <v-text-field
                                v-model="filters.ownName"
                                :label="filtersLabel.ownName"
                                :error-messages="errors.collect('ownName')"
                                data-vv-name="ownName"
                                :data-vv-as="filtersLabel.ownName"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor"> </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor">
                              <v-text-field
                                v-model="filters.engNo"
                                :label="filtersLabel.engNo"
                                :error-messages="errors.collect('engNo')"
                                data-vv-name="engNo"
                                :data-vv-as="filtersLabel.engNo"
                                v-validate="'entry|max:30'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor">
                              <v-text-field
                                v-model="filters.chasNo"
                                :label="filtersLabel.chasNo"
                                :error-messages="errors.collect('chasNo')"
                                data-vv-name="chasNo"
                                :data-vv-as="filtersLabel.chasNo"
                                v-validate="'entry|max:30'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6 v-if="showMotor">
                              <v-text-field
                                v-model="filters.trailerRegNo"
                                :label="filtersLabel.trailerRegNo"
                                :error-messages="errors.collect('trailerRegNo')"
                                data-vv-name="trailerRegNo"
                                :data-vv-as="filtersLabel.trailerRegNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </transition>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn text @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                      <v-btn text @click.native="showDetailFilters = false" v-if="showDetailFilters">Show Less Filters</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout>
        <!-- Policy/Risk Details Tabs Style -->
        <v-flex xs12>
          <v-card>
            <!-- Tabs in Policy list -->
            <v-tabs left v-model="tab">
              <v-tab
                v-model="tab"
                v-for="(detailTab, x) in detailTabs"
                :key="x"
                @click="doColumn(detailTab, columns)"
                :disabled="doDisabledTab(detailTab)"
                >{{ detailTab }}</v-tab
              >
              <v-spacer></v-spacer>
              <v-menu
                v-if="checkAccess([permissionKeys.perm_011050])"
                offset-x
                :nudge-left="370"
                :close-on-content-click="false"
                :min-width="300"
                :max-height="400"
              >
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" class="white--text ma-2" v-on="on">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                </template>
                <v-card v-if="tab === 0">
                  <v-card-text>
                    <template v-if="policyColumns.length > 0">
                      <v-checkbox
                        v-for="column in policyColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolicyColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                </v-card>
                <v-card v-else>
                  <v-card-text v-if="filters.mainClasses === 'Cargo'">
                    <template v-if="polCargoRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polCargoRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolCargoRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Fire'">
                    <template v-if="polFireRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polFireRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolFireRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Hull'">
                    <template v-if="polHullRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polHullRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolHullRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Medical'">
                    <template v-if="polMedRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polMedRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolMedRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Personal Accident'">
                    <template v-if="polPaRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polPaRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolPaRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Miscellaneous'">
                    <template v-if="polMiscRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polMiscRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolMiscRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                  <v-card-text v-if="filters.mainClasses === 'Motor'">
                    <template v-if="polMotorRiskColumns.length > 0">
                      <v-checkbox
                        v-for="column in polMotorRiskColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedPolMotorRiskColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                </v-card>
              </v-menu>
              <v-tab-item :key="1">
                <v-flex xs12 class="mt-2">
                  <v-data-table
                    :headers="listPolicyHeaders"
                    :items="items"
                    v-bind:options.sync="paginationPolHeader"
                    :server-items-length="totalItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td v-for="column in selectedPolicyColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="text-right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="error" text @click.prevent="doUndo(row)" :loading="loading">
                                <v-icon>mdi-replay</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.undo }}</span>
                          </v-tooltip>
                        </td>
                      </tr></template
                    >
                  </v-data-table>
                </v-flex>
              </v-tab-item>
              <v-tab-item :key="2">
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Cargo'">
                  <v-data-table
                    :headers="listPolCargoRiskHeaders"
                    :items="items"
                    v-bind:options.sync="pagination"
                    :server-items-length="totalCargoItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td v-for="column in selectedPolCargoRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="text-right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="error" text @click.prevent="doUndo(row)" :loading="loading">
                                <v-icon>mdi-replay</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.undo }}</span>
                          </v-tooltip>
                        </td>
                      </tr></template
                    >
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Fire'">
                  <v-data-table
                    :headers="listPolFireRiskHeaders"
                    :items="items"
                    v-bind:options.sync="pagination"
                    :server-items-length="totalFireItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td v-for="column in selectedPolFireRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="text-right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="error" text @click.prevent="doUndo(row)" :loading="loading">
                                <v-icon>mdi-replay</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.undo }}</span>
                          </v-tooltip>
                        </td>
                      </tr></template
                    >
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Hull'">
                  <v-data-table
                    :headers="listPolHullRiskHeaders"
                    :items="items"
                    v-bind:options.sync="pagination"
                    :server-items-length="totalHullItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td v-for="column in selectedPolHullRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="text-right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="error" text @click.prevent="doUndo(row)" :loading="loading">
                                <v-icon>mdi-replay</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.undo }}</span>
                          </v-tooltip>
                        </td>
                      </tr></template
                    >
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Medical'">
                  <v-data-table
                    :headers="listPolMedRiskHeaders"
                    :items="items"
                    v-bind:options.sync="pagination"
                    :server-items-length="totalMedItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td v-for="column in selectedPolMedRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="text-right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="error" text @click.prevent="doUndo(row)" :loading="loading">
                                <v-icon>mdi-replay</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.undo }}</span>
                          </v-tooltip>
                        </td>
                      </tr></template
                    >
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Personal Accident'">
                  <v-data-table
                    :headers="listPolPaRiskHeaders"
                    :items="items"
                    v-bind:options.sync="pagination"
                    :server-items-length="totalPaItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td v-for="column in selectedPolPaRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="text-right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="error" text @click.prevent="doUndo(row)" :loading="loading">
                                <v-icon>mdi-replay</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.undo }}</span>
                          </v-tooltip>
                        </td>
                      </tr></template
                    >
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Miscellaneous'">
                  <v-data-table
                    :headers="listPolMiscRiskHeaders"
                    :items="items"
                    v-bind:options.sync="pagination"
                    :server-items-length="totalMiscItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td v-for="column in selectedPolMiscRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="text-right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="error" text @click.prevent="doUndo(row)" :loading="loading">
                                <v-icon>mdi-replay</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.undo }}</span>
                          </v-tooltip>
                        </td>
                      </tr></template
                    >
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="filters.mainClasses === 'Motor'">
                  <v-data-table
                    :headers="listPolMotorRiskHeaders"
                    :items="items"
                    v-bind:options.sync="pagination"
                    :server-items-length="totalMotorItems"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td v-for="column in selectedPolMotorRiskColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="text-right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="error" text @click.prevent="doUndo(row)" :loading="loading">
                                <v-icon>mdi-replay</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.undo }}</span>
                          </v-tooltip>
                        </td>
                      </tr></template
                    >
                  </v-data-table>
                </v-flex>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import clone from 'clone'
import { listPolicyMixin } from '../listPolicyMixin'
import { removeTime, formatDisplayDateTime2 } from '@/utils/date'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatYesNo } from '@/utils/boolean'
import { mapGetters } from 'vuex'
import { permissionKeys } from '@/mixins/global/permissionKey'

export default {
  data() {
    return {
      paginationPolHeader: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      cardMenu: [
        { text: 'Policy', icon: 'mdi-file-document', name: '', params: { tab: 'policy' }, access: '', default: true },
        { text: 'Endorsement', icon: 'mdi-file-multiple', name: '', params: { tab: 'endorse' }, access: '' },
        { text: 'Renewal', icon: 'mdi-refresh', name: '', params: { tab: 'renew' }, access: '' }
      ],
      visibleTab: {},
      tab: undefined,
      policyTab: ['Policy Details'],
      detailTabs: ['Policy Details', 'Risk Details'],
      policyColumns: [
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Ren', value: 'renCnt' },
        { text: 'Endt', value: 'endtCnt' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Pol Type', value: 'polType' },
        { text: 'Com Date', value: 'comDate' },
        { text: 'Exp Date', value: 'expDate' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Stat', value: 'polStat' },
        { text: 'Type', value: 'tranType' },
        { text: 'Rel', value: 'tranRel' },
        { text: 'Bill Acct', value: 'acctNo1' },
        { text: 'Master Pol No. / OC', value: 'moCmpNo' },
        { text: 'Insured Ref No.', value: 'insdRefNo' },
        { text: 'Ced Pol No.', value: 'cedPolNo' },
        { text: 'Ced Ces ', value: 'cedCesNo' },
        { text: 'Broker Slip No.', value: 'brkSlipNo' },
        { text: 'Broker Tran Ref', value: 'brkTranRef' }
      ],
      selectedPolicyColumns: [
        'polNo',
        'renCnt',
        'endtCnt',
        'insdName1',
        'polType',
        'comDate',
        'expDate',
        'tranDate',
        'polStat',
        'tranType',
        'tranRel'
      ],
      polCargoRiskColumns: [
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Ren', value: 'renCnt' },
        { text: 'Endt', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No.', value: 'riskNo' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Vessel Ref ', value: 'vesNo' },
        { text: 'Vessel Name', value: 'vesName' },
        { text: 'Voyage Ref ', value: 'voyNo' },
        { text: 'Voyage Desc ', value: 'voyDesc' }
      ],
      selectedPolCargoRiskColumns: [
        'polNo',
        'renCnt',
        'endtCnt',
        'riskGrpNo',
        'riskNo',
        'insdName1',
        'tranDate',
        'vesNo',
        'vesName',
        'voyNo',
        'voyDesc'
      ],
      polFireRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Risk Location 1', value: 'riskLoc' }
      ],
      selectedPolFireRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'insdName1', 'tranDate', 'riskLoc'],
      polHullRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Vessel Ref ', value: 'vesNo' },
        { text: 'Vessel Name', value: 'vesName' }
      ],
      selectedPolHullRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'insdName1', 'tranDate', 'vesNo', 'vesName'],
      polMedRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'NRIC No. ', value: 'icNo' }
      ],
      selectedPolMedRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'insdName1', 'tranDate', 'icNo'],
      polPaRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'NRIC No. ', value: 'icNo' }
      ],
      selectedPolPaRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'insdName1', 'tranDate', 'icNo'],
      polMiscRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Contract No. ', value: 'contrt' }
      ],
      selectedPolMiscRiskColumns: ['polNo', 'renCnt', 'endtCnt', 'riskGrpNo', 'riskNo', 'insdName1', 'tranDate', 'contrt'],
      polMotorRiskColumns: [
        { text: 'Policy No. ', value: 'polNo' },
        { text: 'Ren ', value: 'renCnt' },
        { text: 'Endt ', value: 'endtCnt' },
        { text: 'Risk Group', value: 'riskGrpNo' },
        { text: 'Risk No. ', value: 'riskNo' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Veh Reg No. ', value: 'vehRegNo' },
        { text: 'Engine No. ', value: 'engNo' },
        { text: 'Chassis No. ', value: 'chasNo' },
        { text: 'Trailer No. ', value: 'trailerRegNo' },
        { text: 'Owner', value: 'ownName' }
      ],
      selectedPolMotorRiskColumns: [
        'polNo',
        'renCnt',
        'endtCnt',
        'riskGrpNo',
        'riskNo',
        'insdName1',
        'tranDate',
        'vehRegNo',
        'engNo',
        'chasNo',
        'trailerRegNo',
        'ownName'
      ],
      params: {
        mainClasses: [
          {
            label: 'All Classes',
            value: 'All Classes'
          },
          {
            label: 'Cargo',
            value: 'Cargo'
          },
          {
            label: 'Fire',
            value: 'Fire'
          },
          {
            label: 'Hull',
            value: 'Hull'
          },
          // {
          //   label: 'Medical',
          //   value: 'Medical'
          // },
          {
            label: 'Miscellaneous',
            value: 'Miscellaneous'
          },
          {
            label: 'Motor',
            value: 'Motor'
          }
          // {
          //   label: 'Personal Accident',
          //   value: 'Personal Accident'
          // }
        ],
        review: [
          {
            label: 'Review',
            value: 'Review'
          },
          {
            label: 'Endorse',
            value: 'Endorse'
          },
          {
            label: 'Renew',
            value: 'Renew'
          },
          {
            label: 'Query',
            value: 'Query'
          }
        ]
      },
      filters: {
        mainClasses: null,
        review: null,
        polNo: null,
        moCmpNo: null,
        insdName1: null,
        comDate: null,
        expDate: null,
        tranDate: null,
        insdRefNo: null,
        acctNo1: null,
        cedPolNo: null,
        cedCesNo: null,
        brkSlipNo: null,
        brkTranRef: null,
        vesNo: null,
        vesName: null,
        voyNo: null,
        voyDesc: null,
        riskLoc: null,
        icNo: null,
        contrt: null,
        vehRegNo: null,
        ownName: null,
        engNo: null,
        chasNo: null,
        trailerRegNo: null,
        riCo: null
      },
      filtersLabel: {
        mainClasses: 'Main Classes',
        review: 'Review',
        polNo: 'Policy No. ',
        moCmpNo: 'Open Cover / Master Policy No.',
        insdName1: 'Insured Name',
        comDate: 'Commencement Date',
        expDate: 'Expiry Date',
        tranDate: 'Transaction Date',
        insdRefNo: 'Insured Reference',
        acctNo1: 'Billing Account No.',
        cedPolNo: 'Cedant Policy No. ',
        cedCesNo: 'Cedant Cession No. ',
        brkSlipNo: 'Broker Slip No. ',
        brkTranRef: 'Broker Transaction Reference',
        vesNo: 'Vessel Reference',
        vesName: 'Vessel Name',
        voyNo: 'Voyage Reference',
        voyDesc: 'Voyage Description',
        riskLoc: 'Risk Location 1',
        icNo: 'Insured NRIC No. ',
        contrt: 'Contract No. ',
        vehRegNo: 'Vehicle Registration No. ',
        ownName: 'Name of Owner',
        engNo: 'Engine No. ',
        chasNo: 'Chassis No. ',
        trailerRegNo: 'Trailer No. ',
        riCo: 'Reinsurer Reference'
      },
      labels: {
        copyPolicy: 'Copy',
        amendPolicy: 'Amend ',
        deletePolicy: 'Delete',
        createPolicy: 'New Policy',
        undo: 'Undo'
      },
      showDetailFilters: false,
      policyTabs: {
        depressed: '',
        name: 'Policy Details'
      },
      riskTabs: {
        depressed: 'depressed',
        name: 'Risk Details'
      },
      showRisk: false,
      showPolicyTabs: true,
      showVesNo: false,
      showVesName: false,
      showVoyNo: false,
      showVoyDesc: false,
      showRiskLoc: false,
      showIcNo: true,
      showContrt: false,
      showMotor: false,
      loadRisk: false,
      policyList: [],
      riskList: [],
      selectedPage: 0,
      showRiskTabs: false,
      permissionKeys: permissionKeys,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'paginationPolHeader': function (value) {
      this.fetchData(false)
    },
    tab: function (value) {
      if (value === 0) {
        this.doColumn('Policy Details', this.columns)
      }
    }
  },
  methods: {
    async fetchData(options) {
      if (this.showPolicyTabs) {
        if (this.apiUrl) {
          try {
            this.loading = true
            const { page, itemsPerPage } = this.paginationPolHeader
            const expand = {
              page: page - 1,
              size: itemsPerPage
            }

            // Massage the filters
            let massageFilters = clone(this.filters)
            if (massageFilters.comDate) {
              massageFilters.comDate = formatDisplayDateTime2(removeTime(massageFilters.comDate))
            }
            if (massageFilters.expDate) {
              massageFilters.expDate = formatDisplayDateTime2(removeTime(massageFilters.expDate))
            }
            if (massageFilters.tranDate) {
              massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
            }
            const result = await this.$http.get(
              filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.paginationPolHeader.sortBy, this.paginationPolHeader.sortDesc)
            )

            if (result.data) {
              this.totalItems = result.data.totalElements
              const { data } = result.data
              if (data) {
                // Format the data here
                this.items = []
                data.map((policy) => {
                  const convertPolicy = {
                    polNo: policy.polNo,
                    renCnt: policy.renCnt,
                    endtCnt: policy.endtCnt,
                    insdName1: policy.insdName1,
                    polType: policy.polType,
                    comDate: this.formatDate(policy.comDate),
                    expDate: this.formatDate(policy.expDate),
                    tranDate: this.formatDate(policy.tranDate),
                    polStat: policy.polStat,
                    tranType: policy.tranType,
                    tranRel: formatYesNo(policy.tranRel),
                    acctNo1: policy.acctNo1,
                    moCmpNo: policy.moCmpNo,
                    insdRefNo: policy.insdRefNo,
                    cedPolNo: policy.cedPolNo,
                    cedCesNo: policy.cedCesNo,
                    brkSlipNo: policy.brkSlipNo,
                    brkTranRef: policy.brkTranRef
                  }
                  this.items.push(convertPolicy)
                })
              } else {
                this.items = []
              }
              this.policyList = this.items
            }
            this.loading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
            this.loading = false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      } else {
        if (this.filters.mainClasses === 'Cargo') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }

              // Massage the filters
              let massageFilters = clone(this.filters)
              if (massageFilters.tranDate) {
                massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalCargoItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.items = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      vesNo: risk.vesNo,
                      vesName: risk.vesName,
                      voyNo: risk.voyNo,
                      voyDesc: risk.voyDesc
                    }
                    this.items.push(convertRisk)
                    this.riskList = this.items
                  })
                } else {
                  this.items = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Fire') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }

              // Massage the filters
              let massageFilters = clone(this.filters)
              if (massageFilters.tranDate) {
                massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalFireItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.items = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      riskLoc: risk.riskLoc
                    }
                    this.items.push(convertRisk)
                    this.riskList = this.items
                  })
                } else {
                  this.items = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Hull') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }

              // Massage the filters
              let massageFilters = clone(this.filters)
              if (massageFilters.tranDate) {
                massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalHullItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.items = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      vesNo: risk.vesNo,
                      vesName: risk.vesName
                    }
                    this.items.push(convertRisk)
                    this.riskList = this.items
                  })
                } else {
                  this.items = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Medical') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }

              // Massage the filters
              let massageFilters = clone(this.filters)
              if (massageFilters.tranDate) {
                massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalMedItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.items = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      icNo: risk.icNo
                    }
                    this.items.push(convertRisk)
                    this.riskList = this.items
                  })
                } else {
                  this.items = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Personal Accident') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }

              // Massage the filters
              let massageFilters = clone(this.filters)
              if (massageFilters.tranDate) {
                massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalPaItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.items = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      icNo: risk.icNo
                    }
                    this.items.push(convertRisk)
                    this.riskList = this.items
                  })
                } else {
                  this.items = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Miscellaneous') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }

              // Massage the filters
              let massageFilters = clone(this.filters)
              if (massageFilters.tranDate) {
                massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalMiscItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.items = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      contrt: risk.contrt
                    }
                    this.items.push(convertRisk)
                    this.riskList = this.items
                  })
                } else {
                  this.items = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else if (this.filters.mainClasses === 'Motor') {
          if (this.apiUrl) {
            try {
              this.loading = true
              const { page, itemsPerPage } = this.pagination
              const expand = {
                page: page - 1,
                size: itemsPerPage,
                options
              }

              // Massage the filters
              let massageFilters = clone(this.filters)
              if (massageFilters.tranDate) {
                massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
              }
              const result = await this.$http.get(
                filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
              )
              if (result.data) {
                this.totalMotorItems = result.data.totalElements
                const { data } = result.data
                if (data) {
                  // Format the data here
                  this.items = []
                  data.map((risk) => {
                    const convertRisk = {
                      polNo: risk.polNo,
                      renCnt: risk.renCnt,
                      endtCnt: risk.endtCnt,
                      riskGrpNo: risk.riskGrpNo,
                      riskNo: risk.riskNo,
                      tranRel: formatYesNo(risk.tranRel),
                      insdName1: risk.insdName1,
                      tranDate: this.formatDate(risk.tranDate),
                      vehRegNo: risk.vehRegNo,
                      engNo: risk.engNo,
                      chasNo: risk.chasNo,
                      trailerRegNo: risk.trailerRegNo,
                      ownName: risk.ownName
                    }
                    this.items.push(convertRisk)
                    this.riskList = this.items
                  })
                } else {
                  this.items = []
                }
              }
              this.loading = false
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            }
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        }
      }
    },
    valMainClasses() {
      if (this.filters.mainClasses === 'All Classes') {
        this.showRisk = false
      } else {
        this.showVesNo = false
        this.showVesName = false
        this.showVoyNo = false
        this.showVoyDesc = false
        this.showRiskLoc = false
        this.showIcNo = false
        this.showContrt = false
        this.showMotor = false
        if (this.filters.mainClasses === 'Cargo') {
          this.showVesNo = true
          this.showVesName = true
          this.showVoyNo = true
          this.showVoyDesc = true
        } else if (this.filters.mainClasses === 'Fire') {
          this.showRiskLoc = true
        } else if (this.filters.mainClasses === 'Hull') {
          this.showVesNo = true
          this.showVesName = true
        } else if (this.filters.mainClasses === 'Medical') {
          this.showIcNo = true
        } else if (this.filters.mainClasses === 'Miscellaneous') {
          this.showContrt = true
        } else if (this.filters.mainClasses === 'Motor') {
          this.showMotor = true
        } else if (this.filters.mainClasses === 'Personal Accident') {
          this.showIcNo = true
        }
        this.showRisk = true
      }
    },
    doUndo(data) {
      this.loading = true
      this.$store.dispatch('reviewPolicy', data).then(() => {
        this.$router.push({ name: 'undoPolicyRelease' })
        this.loading = false
      })
    },
    doClearFilters() {
      this.filters.mainClasses = this.params.mainClasses[0].value
      this.filters.polNo = null
      this.filters.moCmpNo = null
      this.filters.insdName1 = null
      this.filters.comDate = null
      this.filters.expDate = null
      this.filters.tranDate = null
      this.filters.insdRefNo = null
      this.filters.acctNo1 = null
      this.filters.cedPolNo = null
      this.filters.cedCesNo = null
      this.filters.brkSlipNo = null
      this.filters.brkTranRef = null
      this.filters.vesNo = null
      this.filters.vesName = null
      this.filters.voyNo = null
      this.filters.voyDesc = null
      this.filters.riskLoc = null
      this.filters.icNo = null
      this.filters.contrt = null
      this.filters.vehRegNo = null
      this.filters.ownName = null
      this.filters.engNo = null
      this.filters.chasNo = null
      this.filters.trailerRegNo = null
      this.filters.riCo = null

      this.showVesNo = false
      this.showVesName = false
      this.showVoyNo = false
      this.showVoyDesc = false
      this.showRiskLoc = false
      this.showIcNo = true
      this.showContrt = false
      this.showMotor = false

      this.loadRisk = false
      this.loadPolicy = false
      this.policyList = []
      this.riskList = []

      this.showRisk = false
      this.showRiskTabs = false

      this.apiUrl = this.listState.policyListing
      this.showPolicyTabs = true
      this.tab = 0

      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      if (this.tab === 0) {
        this.loadPolicy = true
        this.loadRisk = false
      } else {
        this.loadPolicy = false
        this.loadRisk = true
      }
      if (this.showRisk) {
        this.showRiskTabs = true
      } else {
        this.showRiskTabs = false
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.paginationPolHeader.page = 1
          this.fetchData(false)
        }
      })
    },
    doRiskTabs() {
      this.showPolicyTabs = false
      if (!this.loadRisk) {
        this.items = []
        this.loadRisk = true
        this.fetchData(false)
      } else {
        this.items = this.riskList
      }
    },
    doPolicyTabs() {
      this.showPolicyTabs = true
      if (!this.loadPolicy) {
        this.items = []
        this.loadPolicy = true
        this.fetchData(false)
      } else {
        this.items = this.policyList
      }
    },
    doColumn(detailTab, columns) {
      this.columns = []
      if (detailTab === 'Policy Details') {
        this.apiUrl = this.listState.policyListing
        this.doPolicyTabs()
      } else if (detailTab === 'Risk Details') {
        this.apiUrl = this.listState.policyRiskListing
        this.doRiskTabs()
      }
    },
    doDisabledTab(detailTab) {
      if (detailTab === 'Risk Details' && this.showRiskTabs === false) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.filters.mainClasses = this.params.mainClasses[0].value
    this.filters.review = 'undo'
    this.apiUrl = this.listState.policyListing
  },
  mixins: [listPolicyMixin],
  computed: {
    ...mapGetters(['checkAccess'])
  }
}
</script>

<style lang="scss">
@import '../../../../assets/scss/underwriting.scss';
</style>
